import { render, staticRenderFns } from "./EscolherLoja.vue?vue&type=template&id=6f265f2e&scoped=true&"
import script from "./EscolherLoja.vue?vue&type=script&lang=js&"
export * from "./EscolherLoja.vue?vue&type=script&lang=js&"
import style0 from "./EscolherLoja.vue?vue&type=style&index=0&id=6f265f2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f265f2e",
  null
  
)

export default component.exports